import {DurationRentalOtherFacilityReservation} from '../ReserveAvailabilityDuration'
import {RESERVATION_STATUS} from '../../../CodeMaster'

export interface OutOfHourDuration {
    startDateTime: string
    endDateTime: string
}

export default class AdminReserveAvailabilityDuration {
    condominiumCd: string
    facilityId: number
    targetDate: string
    otherReserves: DurationRentalOtherFacilityReservation[]
    outOfHours: OutOfHourDuration[]

    constructor(
        condominiumCd: string,
        facilityId: number,
        targetDate: string,
        otherReserves: DurationRentalOtherFacilityReservation[] = [],
        outOfHourDuration: OutOfHourDuration[],
    ) {
        this.condominiumCd = condominiumCd
        this.facilityId = facilityId
        this.targetDate = targetDate
        this.otherReserves = otherReserves
        this.outOfHours = outOfHourDuration
    }

    static from(json: any): AdminReserveAvailabilityDuration {
        return new AdminReserveAvailabilityDuration(
            json.condominiumCd,
            json.facilityId,
            json.targetDate,
            json.otherReserves.map((other: any) => {
                const {status, ...rest} = other
                return {
                    ...rest,
                    status: RESERVATION_STATUS.codeToEnumConstants(status),
                }
            }),
            json.outOfHours,
        )
    }
}
